export default __webpack_public_path__ + "static/media/v3play.033c1513.png";